import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Pages from './Pages';
import Tooltip from '../Tooltip';
import AsideExpend from './AsideExpend';
import { Aside, AsideMain } from './BuilderAside.sc';
import useClickOutside from '../../hooks/useClickOutside';
import { useRef } from 'react';

function BuilderAside({
    activeSidebar,
    showSettingsModal,
    toggleActiveSidebar,
    ...restOfProps
}) {
    const expendRef = useRef();
    const getActiveClassName = useCallback(
        (type) => (activeSidebar === type ? 'active' : ''),
        [activeSidebar]
    );

    const handleClose = React.useCallback(() => {
        if (expendRef?.current) expendRef.current.style.left = null;
        setTimeout(() => {
            toggleActiveSidebar('');
        }, 350);
    }, [toggleActiveSidebar]);

    const asideRef = useClickOutside(() => handleClose());

    React.useEffect(() => {
        if (expendRef?.current) {
            if (activeSidebar) {
                expendRef.current.style.left = '50px';
            }
        }
    }, [activeSidebar]);

    return (
        <Aside ref={asideRef}>
            <AsideMain>
                <Tooltip
                    effect="hover"
                    content="Pages"
                    placement="right"
                    className={getActiveClassName('PAGES')}
                    onClick={() => toggleActiveSidebar('PAGES')}
                >
                    <FontAwesomeIcon icon={['far', 'file']} />
                </Tooltip>
                <Tooltip
                    effect="hover"
                    placement="right"
                    content="Global Styles"
                    className={getActiveClassName('GLOBAL-SETTINGS')}
                    onClick={() => showSettingsModal('GLOBAL-SETTINGS')}
                >
                    <FontAwesomeIcon icon={['far', 'pencil-paintbrush']} />
                </Tooltip>
                <Tooltip
                    effect="hover"
                    placement="right"
                    content="Site Settings"
                    className={getActiveClassName('SITE-SETTINGS')}
                    onClick={() => showSettingsModal('SITE-SETTINGS')}
                >
                    <FontAwesomeIcon icon={['far', 'cogs']} />
                </Tooltip>
            </AsideMain>
            {activeSidebar && (
                <AsideExpend
                    ref={expendRef}
                    close={handleClose}
                    title={activeSidebar}
                >
                    {activeSidebar === 'PAGES' && <Pages {...restOfProps} />}
                </AsideExpend>
            )}
        </Aside>
    );
}

export default BuilderAside;
